module.exports = __webpack_public_path__ + "img/contact.bf32612a.jpg";